import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function DeleteCrd() {
  const [search, setSearch] = useState("");

  const [crdList, setCrdList] = useState([]);
  const token = sessionStorage.getItem("token");

  /* ===============================
      FETCH ALL CRD
  =============================== */
  const fetchCRD = async () => {
    try {
      const res = await axios.get("https://irc.zentelex.com/api/delete/crd", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCrdList(res.data.data || []);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Unable to load CRD data",
      });
    }
  };

  useEffect(() => {
    fetchCRD();
  }, []);

  /* ===============================
      DELETE CRD
  =============================== */
  



const handleDelete = async (crd) => {

  /* ========= TRUCK DETAILS HTML ========= */
  const truckHTML =
    crd.truckDetails?.length > 0
      ? crd.truckDetails
          .map(
            (t, i) => `
              <tr>
                <td>${i + 1}</td>
                <td>${t.truckNo}</td>
                <td>${t.netWeight}</td>
                <td>${t.noOfBags}</td>
              </tr>
            `
          )
          .join("")
      : `<tr><td colspan="4">No Truck Details</td></tr>`;

  /* ========= CONFIRM MODAL ========= */
  const result = await Swal.fire({
    title: "⚠ CRD Delete Confirmation",
    width: 900,
    icon: "warning",
    html: `
      <div style="text-align:left;font-size:14px">

        <h5 style="color:#0d6efd">📄 CRD Details</h5>

        <b>CRD No:</b> ${crd.crdNo}<br/>
        <b>Receipt Date:</b> ${crd.receiptDate}<br/>
        <b>Client:</b> ${crd.clientName}<br/>
        <b>Client Address:</b> ${crd.clientAddress}<br/>

        <hr/>

        <h5 style="color:#0d6efd">🏭 Warehouse Info</h5>

        <b>Warehouse:</b> ${crd.warehouseName}<br/>
        <b>Location:</b> ${crd.locationName || "-"}<br/>
        <b>Warehouse Address:</b> ${crd.warehouseAddress}<br/>

        <hr/>

        <h5 style="color:#0d6efd">📦 Commodity Info</h5>

        <b>Commodity:</b> ${crd.commodityName}<br/>
        <b>Variety:</b> ${crd.variety}<br/>
        <b>No Of Bags:</b> ${crd.noOfBags}<br/>
        <b>Quantity MT:</b> ${crd.quantityMT}<br/>
        <b>Stack No:</b> ${crd.stackNo}<br/>
        <b>Rate Per MT:</b> ${crd.ratePerMT}<br/>
        <b>Packing Quality:</b> ${crd.packingQuality}<br/>
        <b>Private Mark:</b> ${crd.privateIdMark || "-"}<br/>
        <b>Remarks:</b> ${crd.remarks}<br/>

        <hr/>

        <h5 style="color:#0d6efd">🚚 Truck Details</h5>

        <table style="width:100%;border-collapse:collapse" border="1">
          <thead>
            <tr>
              <th>#</th>
              <th>Truck No</th>
              <th>Net Weight</th>
              <th>No Of Bags</th>
            </tr>
          </thead>
          <tbody>
            ${truckHTML}
          </tbody>
        </table>

        <hr/>

    

        <hr/>
        <p style="color:red;font-weight:bold">
          This action cannot be undone!
        </p>

      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "🗑 Yes Delete",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
  });

  if (!result.isConfirmed) return;

  /* ========= DELETE ========= */
  try {
    Swal.fire({
      title: "Deleting...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    await axios.delete(
      `https://irc.zentelex.com/api/delete/crd/${crd.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Deleted!",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchCRD();
  } catch (error) {
    Swal.fire("Error", "Delete Failed", "error");
  }
};








  const filteredCrdList = crdList.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.crdNo?.toLowerCase().includes(text) ||
      item.clientName?.toLowerCase().includes(text) ||
      item.warehouseName?.toLowerCase().includes(text) ||
      item.commodityName?.toLowerCase().includes(text)
    );
  });

  return (
    <div className="container mt-4">
      <h4 className="mb-4 fw-bold">Delete CRD Records</h4>

      <div className="mb-3">
        <input
          type="text"
          className="form-control border-primary"
          placeholder="🔍 Search CRD / Client / Warehouse / Product..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>CRD No</th>
              <th>Client Name</th>
              <th>Warehouse</th>
              <th>Product</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredCrdList.length > 0 ? (
              filteredCrdList.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.crdNo}</td>
                  <td>{item.clientName}</td>
                  <td>{item.warehouseName}</td>
                  <td>{item.commodityName}</td>

                  <td>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(item)}
                    >
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
